var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.hero},[_c('the-toolbar',{staticStyle:{"z-index":"1","position":"relative","margin-bottom":"6.15rem"},on:{"login":_vm.onLogin}}),_c('the-tabs',{ref:"nav",staticStyle:{"position":"absolute","bottom":"-0.75rem","left":"0"},attrs:{"active-tab":_vm.activeTab},on:{"tab-click":_vm.onTabClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }